//@vendor
const moment = require('moment');
const get = require('lodash/object/get');
const { createActions } = require('redux-actions');
//@utilities
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const { formatAmount, formatNumber } = require('utilities/currencyHelper');
const download = require('downloadjs');
const BrowserUtils = require('utilities/browserUtils');
const DateHelper = require('utilities/dateHelper');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');
const notificationActions = require('actions/notifications');
const { getLoanRecordStatus } = require('actions/loanRecordStatus');
const { getInitPropositionNumber, getInitPropositionNumberPolicy, getLoanInitINEContractDocumentsPreaproved } = require('actions/commons/contractInit');
const { getAsnefValidation } = require('./contractEasyLoan');
const { validateAndExecute } = require('actions/signaturePattern');

// @core
const { formatText } = require('core/i18n').i18n;

//@constants
const {
    PRE_CONTRACTUAL_EASY_LOAN_MAIL,
    NOT_ALLOWED_NEW_PREAPPROVAL_LOAN_FLOW_COUNTRIES,
    EASY_LOAN_LEGAL_CHECK,
    NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES,
    EVIDENCE_EASY_LOAN
} = require('constants/flagBasedFeatures');
const { WIZARD_SECOND_STEP, WIZARD_FIRST_STEP, DATE_FORMAT_API, EURO_TEXT, EASY_LOAN_MAILTYPE } = require('constants/index');
const translationContractLoanPdfViewerINE = require("../components/contracts/contractLoanPdfViewerINE/contractLoanPdfViewerINE.translations");
const { es: { DATE_FORMAT_WITH_SLASHES } } = require('commonsConstants/dateFormatTypes');
const {
    payrollLoanCommon, loanPurposes, DEFAULT_BEFORE_STEP,
    payrollLoanRecordStatus: { requestStatus: { PRE_APPROVAL_OK } },
    EASY_LOAN_TYPEC_CRIBE_CONST,
    contractEasyLoan: {
        LANGUAGE,
        PAYMENT_DAY_END_OF_MONTH,
        PRODUCT_TYPE,
        contractEasyLoanEmail: {
            TEMPLATE_CODE,
        }
    },
    amortizationTypes,
    easyLoanErrorDocument: { NOM_VL, IRPF100, IRPF130, IRPF100_CLI, IRPF100_CLI_2, NEW_IRPF100_FILE, IRPF100_CLI_3, IRPF100_CLI_4 },
    easyLoanTypeUpload: {
        IRPF_FILE,
        IRPF130_FILE,
        IRPF100_FILE,
        IRPF100_CLI_FILE,
        IRPF100_CLI_FILE_2,
        IRPF100_CLI_FILE_3,
        IRPF100_CLI_FILE_4,
        EASY_LOAN_CERTIFICATE,
    },
    PAYROLL_LOAN_PRE_APPROVED_STATUS: {
        ASNEF_VALIDATION_ERROR
    },
    VERSION_2
} = require('../loansConstants/index');

//@helpers
const { downLoadDocumentInOtherPage, getTranslatedDocumentName } = require('../loansUtilities/loansHelper');
const { recordEasyLoanCUploadFileSuccess } = require('../components/contracts/contractEasyLoanTypeC/analytics/contractEasyLoanTypeC.tracking');

const simpleActions = createActions(

    'CONTRACT_EASY_LOAN_DOWNLOAD_DOCUMENT',
    'CONTRACT_EASY_LOAN_DOWNLOAD_DOCUMENT_ERROR',
    'CONTRACT_EASY_LOAN_DOWNLOAD_DOCUMENT_SUCCESS',

    'CONTRACT_EASY_LOAN_DOWNLOAD_PRINT_DOCUMENT',
    'CONTRACT_EASY_LOAN_DOWNLOAD_PRINT_DOCUMENT_ERROR',
    'CONTRACT_EASY_LOAN_DOWNLOAD_PRINT_DOCUMENT_SUCCESS',

    'CONTRACT_EASY_LOAN_FORMALIZE',
    'CONTRACT_EASY_LOAN_FORMALIZE_ERROR',
    'CONTRACT_EASY_LOAN_FORMALIZE_SUCCESS',

    'CONTRACT_EASY_LOAN_TYPEC_GET_PROPOSITION',
    'CONTRACT_EASY_LOAN_TYPEC_GET_PROPOSITION_ERROR',
    'CONTRACT_EASY_LOAN_TYPEC_GET_PROPOSITION_SUCCESS',
    'CONTRACT_EASY_LOAN_TYPEC_EMAIL_SUCCESS',
    'CONTRACT_EASY_LOAN_TYPEC_EMAIL_ERROR',

    'CONTRACT_EASY_LOAN_TYPEC_GET_TOTAL_IMPORT',
    'CONTRACT_EASY_LOAN_TYPEC_GET_TOTAL_IMPORT_ERROR',
    'CONTRACT_EASY_LOAN_TYPEC_GET_TOTAL_IMPORT_SUCCESS',

    'CONTRACT_EASY_LOAN_HIRING_DOCUMENTS',
    'CONTRACT_EASY_LOAN_HIRING_DOCUMENTS_ERROR',
    'CONTRACT_EASY_LOAN_HIRING_DOCUMENTS_SUCCESS',

    'CONTRACT_EASY_LOAN_INSTALLMENT',
    'CONTRACT_EASY_LOAN_INSTALLMENT_ERROR',
    'CONTRACT_EASY_LOAN_INSTALLMENT_SUCCESS',

    'CONTRACT_EASY_LOAN_TYPEC_MIN_INSTALLMENT',
    'CONTRACT_EASY_LOAN_TYPEC_MIN_INSTALLMENT_ERROR',
    'CONTRACT_EASY_LOAN_TYPEC_MIN_INSTALLMENT_SUCCESS',

    'CONTRACT_EASY_LOAN_NOT_AVAILABLE',

    'CONTRACT_EASY_LOAN_PRE_FILL',
    'CONTRACT_EASY_LOAN_PRE_FILL_ERROR',
    'CONTRACT_EASY_LOAN_PRE_FILL_SUCCESS',

    'CONTRACT_EASY_LOAN_TYPEC_RESET_STEP',
    'CONTRACT_EASY_LOAN_SET_ACCOUNT',
    'CONTRACT_EASY_LOAN_SET_LOAN_AMOUNT',
    'CONTRACT_EASY_LOAN_SET_PAYMENT_DAY',
    'CONTRACT_EASY_LOAN_SET_PURPOSE',
    'CONTRACT_EASY_LOAN_TYPEC_SET_STEP',
    'CONTRACT_EASY_LOAN_TYPEC_SET_TERM',
    'CONTRACT_EASY_LOAN_TOGGLE_AGREE_CHECKBOX',
    'CONTRACT_EASY_LOAN_TYPEC_INE_TOGGLE_AGREE_CHECKBOX',
    'CONTRACT_EASY_LOAN_TYPEC_PRINT_STEP2',
    'CONTRACT_EASY_LOAN_VALIDATE_STEP',
    'CONTRACT_EASY_LOAN_TYPEC_VALIDATE_STEP',
    'CONTRACT_EASY_LOAN_VALIDATE_STEP_APPROVED',
    'CONTRACT_EASY_LOAN_TYPEC_WILL_LEAVE',

    'PAYROLL_LOAN_REQUEST_EMAIL_PRECONTRACTUAL',
    'PAYROLL_LOAN_REQUEST_EMAIL_PRECONTRACTUAL_SUCCESS',
    'PAYROLL_LOAN_REQUEST_EMAIL_PRECONTRACTUAL_ERROR',

    'CONTRACT_EASY_LOAN_TYPEC_SET_NEW_JOB_TYPE',
    'CONTRACT_EASY_LOAN_TYPEC_SET_EMPLOYMENT_LEVEL',
    'CONTRACT_EASY_LOAN_TYPEC_SET_CONTRACT_TYPE',
    'CONTRACT_EASY_LOAN_TYPEC_SET_OUTCOME',
    'CONTRACT_EASY_LOAN_TYPEC_SET_ERROR',

    'CONTRACT_EASY_LOAN_TYPEC_INITIALIZE',
    'CONTRACT_EASY_LOAN_TYPEC_INITIALIZE_ERROR',
    'CONTRACT_EASY_LOAN_TYPEC_INITIALIZE_SUCCESS',

    'CONTRACT_EASY_LOAN_TYPEC_GET_JOBS',
    'CONTRACT_EASY_LOAN_TYPEC_GET_JOBS_ERROR',
    'CONTRACT_EASY_LOAN_TYPEC_GET_JOBS_SUCCESS',

    'EASY_LOAN_TYPEC_REQUEST_SAVE_IN_PROGRESS',
    'EASY_LOAN_TYPEC_REQUEST_SAVE_IN_PROGRESS_ERROR',
    'EASY_LOAN_TYPEC_REQUEST_SAVE_IN_PROGRESS_SUCCESS',

    'CONTRACT_EASY_LOAN_TYPEC_INSTALLMENT',
    'CONTRACT_EASY_LOAN_TYPEC_INSTALLMENT_ERROR',
    'CONTRACT_EASY_LOAN_TYPEC_INSTALLMENT_SUCCESS',

    'EASY_LOAN_TYPEC_REQUEST_GET_LOANS_FOR_EXPENSES',
    'EASY_LOAN_TYPEC_REQUEST_GET_LOANS_FOR_EXPENSES_ERROR',
    'EASY_LOAN_TYPEC_REQUEST_GET_LOANS_FOR_EXPENSES_SUCCESS',

    'CONTRACT_EASY_LOAN_TYPEC_REQUEST_APPROVAL',
    'CONTRACT_EASY_LOAN_TYPEC_REQUEST_APPROVAL_REJECTED',
    'CONTRACT_EASY_LOAN_TYPEC_REQUEST_APPROVAL_APPROVED',
    'CONTRACT_EASY_LOAN_TYPEC_REQUEST_APPROVAL_ERROR',

    'EASY_LOAN_REQUEST_SAVE_IN_PROGRESS_ERROR',

    'CONTRACT_EASY_LOAN_TYPEC_GET_PURPOSES',
    'CONTRACT_EASY_LOAN_TYPEC_GET_PURPOSES_SUCCESS',
    'CONTRACT_EASY_LOAN_TYPEC_GET_PURPOSES_ERROR',

    'GET_EASY_LOAN_TYPEC_INE_DOCUMENT',
    'GET_EASY_LOAN_TYPEC_INE_DOCUMENT_SUCCESS',
    'GET_EASY_LOAN_TYPEC_INE_DOCUMENT_ERROR',

    'CONTRACT_EASY_LOAN_TYPEC_SET_PURPOSE',
    'CONTRACT_EASY_LOAN_TYPEC_READ_DOCUMENT',
    'CONTRACT_EASY_LOAN_TYPEC_READ_DOCUMENT_POLICY',
    'CONTRACT_EASY_LOAN_TYPEC_TOGGLE_AGREE_CHECKBOX',
    'CONTRACT_SHOW_TYPE_C',

    'EASY_LOAN_REQUEST_UPLOAD_FILE',
    'EASY_LOAN_REQUEST_UPLOAD_FILE_DISABLE',
    'EASY_LOAN_REQUEST_UPLOAD_FILE_ERROR',
    'EASY_LOAN_REQUEST_UPLOAD_FILE_LOAD',
    'EASY_LOAN_REQUEST_UPLOAD_FILE_INVALID_ERROR',

    'CONTRACT_EASY_LOAN_FORMALIZE_SUCCESS',
    'CONTRACT_EASY_LOAN_FORMALIZE_ERROR',

    'EASY_LOAN_REQUEST_UPLOAD_FILE_REMOVE',
    'EASY_LOAN_REQUEST_UPLOAD_FILE_REMOVE_ERROR',
    'EASY_LOAN_REQUEST_UPLOAD_FILE_REMOVE_SUCCESS',

    'EASY_LOAN_REQUEST_UPLOAD_START_CONFIRM',
    'EASY_LOAN_REQUEST_UPLOAD_FILE_RESET',
    'EASY_LOAN_REQUEST_UPLOAD_FILE_SUBMIT',
    'EASY_LOAN_REQUEST_UPLOAD_FILE_SUCCESS',

    'EASY_LOAN_REQUEST_LOAD_FILES',
    'EASY_LOAN_REQUEST_LOAD_FILES_ERROR',
    'EASY_LOAN_REQUEST_LOAD_FILES_SUCCESS',
    'EASY_LOAN_REQUEST_FINISH_WITHOUT_UPLOAD',
    'EASY_LOAN_REQUEST_UPLOAD_FILE_SUBMIT_CONTACT_CENTER',
    'CONTRACT_EASY_LOAN_TYPEC_STEP_THREE',
    'CONTRACT_EASY_LOAN_TYPEC_UPDATE_LOAN_INFO',
    'CONTRACT_EASY_LOAN_TYPEC_ASNEF_FAILURE',
    'CONTRACT_EASY_LOAN_TYPEC_ASNEF_FAILURE_RESET',
);

const messageUploadExternalErrorText = 'payrollLoanRequestStepThree-payrollLoanRequestStepThree_uploadExternalErrorText';
const messageDeleteOrChangeNameErrorText = 'payrollLoanDocumentsUpload-fileErrorText';

const onDownloadDocument = (productName) => (dispatch, getState) => {
    const immContractEasyLoanTypeC = getState().contractEasyLoanTypeC;
    const immContractEasyLoan = getState().contractEasyLoan;
    const accounts = getState().accounts;

    const isFetchingZip = immContractEasyLoanTypeC.get('isFetchingZip');

    if (!isFetchingZip) {
        const endOfMonth = immContractEasyLoanTypeC.get('paymentDaySelected') === PAYMENT_DAY_END_OF_MONTH;
        const financedCommission = immContractEasyLoanTypeC.get('indCapson') === amortizationTypes.YES ?
            payrollLoanCommon.FINANCIADA : payrollLoanCommon.NO_FINANCIADA;

        const params = {
            header: {
                responseType: 'arraybuffer'
            },
            query: {
                amount: formatAmount(immContractEasyLoanTypeC.get('selectedAmount'), 'es'),
                calculatedOpeningCommission: formatAmount(immContractEasyLoanTypeC.getIn(['openingCommission', 'amount']), 'es'),
                capitalizedOpeningCommissionIndicator: immContractEasyLoanTypeC.get('indCapson'),
                clientAccountCode: accounts.getIn(['byId', immContractEasyLoanTypeC.get('selectedAccount'), 'iban']),
                dueDate: moment(immContractEasyLoanTypeC.get('loanDueDate')).format(DATE_FORMAT_WITH_SLASHES),
                endOfMonth,
                financedCommission,
                firstTime: true, //fixed value. The user hasn't contracted the loan yet in this step. So we show a template.
                loanPurpose: loanPurposes[immContractEasyLoanTypeC.get('selectedPurpose')],
                productDuration: immContractEasyLoanTypeC.get('selectedTerm').toString(),
                propositionContractNumber: immContractEasyLoanTypeC.get('contractNumber'),
                propositionNumber: immContractEasyLoan.get('propositionNumber').toString(),
                tae: formatAmount(immContractEasyLoanTypeC.get('tae'), 'es'),
                tin: formatAmount(immContractEasyLoanTypeC.get('tin'), 'es'),
                year: immContractEasyLoan.get('propositionYear'),
                productType: PRODUCT_TYPE
            }
        };

        dispatch(simpleActions.contractEasyLoanDownloadDocument());
        APIPost({ dispatch, endpoint: 'loanHiringDocumentsZip', params })
            .then(response => {
                dispatch(simpleActions.contractEasyLoanDownloadDocumentSuccess());
                download(response.xhr.response, `${productName}.zip`, 'application/zip');
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(simpleActions.contractEasyLoanDownloadDocumentError({ error: response.error }));
                } else {
                    throw response;
                }
            });
    }
};

const setNewJobType = jobType => dispatch => {
    dispatch(simpleActions.contractEasyLoanTypecSetNewJobType({ jobType }));
};

const validateJobInformationDrago = (getState) => {
    const contractEasyLoanTypeC = getState().contractEasyLoanTypeC;
    let jobError;

    const jobTypeDrago = contractEasyLoanTypeC.get('newJobType');
    const jobLevelDrago = contractEasyLoanTypeC.get('employmentLevel');
    const contractTypeDrago = contractEasyLoanTypeC.get('contractType');

    if (jobTypeDrago) {
        const newJobTypesList = contractEasyLoanTypeC.get('newJobTypesList');
        const newJobType = newJobTypesList.find(newJobType => jobTypeDrago === newJobType.get('value'));
        const thereAreJobLevel = newJobType && newJobType.get('jobLevel').find(jobLevel => jobLevel.get('visible'));
        if (thereAreJobLevel) {
            if (jobLevelDrago) {
                const employmentLevelList = typeof contractEasyLoanTypeC.get('employmentLevelList').toJS !== 'undefined' ?
                    contractEasyLoanTypeC.get('employmentLevelList').toJS() : contractEasyLoanTypeC.get('employmentLevelList');
                const employmentLevel = employmentLevelList.find(employmentLevel => jobLevelDrago === employmentLevel.value);
                const contractTypeList = employmentLevel.contractType && typeof employmentLevel.contractType.toJS !== 'undefined' ? employmentLevel.contractType.toJS() : employmentLevel.contractType
                const thereAreContractType = contractTypeList.some(contractType => contractType.visible);
                if (thereAreContractType) {
                    jobError = !contractTypeDrago;
                } else {
                    jobError = false;
                }
            } else {
                jobError = true;
            }
        } else {
            jobError = false;
        }
    } else {
        jobError = true;
    }

    return jobError;
}

const contractEasyLoanTypecAsnefFailureReset = () => (dispatch) => {
    dispatch(simpleActions.contractEasyLoanTypecAsnefFailureReset());
};

const setEmploymentLevel = employmentLevel => dispatch => {
    dispatch(simpleActions.contractEasyLoanTypecSetEmploymentLevel({ employmentLevel: employmentLevel.value }));
};

const setContractType = contractType => dispatch => {
    dispatch(simpleActions.contractEasyLoanTypecSetContractType({ contractType: contractType.value }));
};

const setPurpose = (purpose) => (dispatch) => {
    dispatch(simpleActions.contractEasyLoanTypecSetPurpose(purpose));
};

const setOutcome = (outcome) => dispatch => {
    dispatch(simpleActions.contractEasyLoanTypecSetOutcome({ outcome }));
    dispatch(simpleActions.contractEasyLoanTypecSetError({ incomeError: !outcome.income }));
};
const getInstallmentPreapproved = () => (dispatch) => {
    dispatch(getInstallmentRequest())
        .then(() => dispatch(getTotalImportForStepTwo()))
        .then(() => dispatch(easyLoanTypeCSaveInProgress()));
}
const getInstallment = () => (dispatch) => {
    dispatch(getInstallmentRequest())
        .then(() => dispatch(getTotalImportForStepTwo()))
}
const getInstallmentApprove = () => (dispatch) => {
    dispatch(getInstallmentRequest())
        .then(() => dispatch(getTotalImportForStepTwo()))
}
const easyLoanTypeCSaveInProgress = () => (dispatch, getState) => {

    const immEasyLoanTypeC = getState().contractEasyLoanTypeC;
    const sumOtherLoanInstallments = immEasyLoanTypeC.getIn(['outcome', 'expenses']) + immEasyLoanTypeC.get('totalMonthlyFee');
    const jobTypeDrago = immEasyLoanTypeC.get('selectedJobType');

    const expDate = immEasyLoanTypeC.getIn(['productoActivoSegmentado', 'fechaVigencia']);
    const tinAmount = immEasyLoanTypeC.get('tin');
    const selectedPurpose = immEasyLoanTypeC.get('selectedPurpose');
    const taeAmout = immEasyLoanTypeC.get('tae');
    const employmentLevel = immEasyLoanTypeC.get('employmentLevel');
    const contractType = immEasyLoanTypeC.get('contractType');
    const params = {
        query: {
            tin: tinAmount,
            tae: taeAmout,
            expDate: expDate,
            amount: immEasyLoanTypeC.get('selectedAmount'),
            monthlyFee: immEasyLoanTypeC.getIn(['installment', 'amount']) || 0,
            purpose: "",
            purposeDrago: selectedPurpose,
            subPurposeDrago: "",
            recordId: immEasyLoanTypeC.get('recordId'),
            term: immEasyLoanTypeC.get('selectedTerm'),
            userType: immEasyLoanTypeC.get('userType'),
            confirmDocumentsNeeded: true,
            financialInformation: {
                additionalPayments: immEasyLoanTypeC.getIn(['income', 'extra']),
                housingType: immEasyLoanTypeC.get('regime') || "",
                jobSeniorityInMonths: null,
                jobSeniorityInYears: 0,
                jobType: "",
                mortgageFee: 0,
                maritalStatus: "",
                netIncome: immEasyLoanTypeC.getIn(['outcome', 'income']) || 0,
                numberOfCreditCards: 0,
                otherLoanInstallments: sumOtherLoanInstallments,
                rent: immEasyLoanTypeC.getIn(['outcome', 'rental']) || 0,
                totalJobInMonths: null,
                totalJobInYears: null,
                jobTypeDrago: jobTypeDrago,
                jobLevelDrago: employmentLevel || "",
                contractTypeDrago: contractType || "",
                housingTypeDrago: null,
            }
        }
    };

    dispatch(simpleActions.easyLoanTypecRequestSaveInProgress());
    return APIPost({ dispatch, endpoint: 'contractEasyLoanTypeCSaveInProgress', params })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.easyLoanTypecRequestSaveInProgressError({ error: response.error }));
            } else {
                throw response;
            }
        }).then(() => dispatch(simpleActions.easyLoanTypecRequestSaveInProgressSuccess()));
}

const onPrintDocument = () => (dispatch, getState) => {
    const immContractEasyLoan = getState().contractEasyLoanTypeC;
    const documents = immContractEasyLoan.get('documents');
    const data = [new Uint8Array(documents)];

    const blobObject = new Blob(data, { type: 'application/pdf' });

    if (BrowserUtils.browserIsIE()) {
        window.navigator.msSaveOrOpenBlob(blobObject);
    } else {
        const blobURL = window.URL.createObjectURL(blobObject);
        const winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
            'resizable,screenX=50,screenY=50,width=850,height=1050';
        const printWindow = window.open(blobURL, '', winparams);

        if (printWindow) {
            printWindow.print();
        }
    }
};

const downloadPreContractDocument = () => (dispatch, getState) => {
    const immContractEasyLoan = getState().contractEasyLoan;

    const params = {
        query: {
            estandar: immContractEasyLoan.get('standard'),
            subtipo: immContractEasyLoan.get('subtype'),
            tipo: immContractEasyLoan.get('type'),
            idioma: LANGUAGE
        }
    };

    dispatch(simpleActions.contractEasyLoanDownloadPrintDocument());
    APIGet({ dispatch, endpoint: 'requestPreContractActive', params }).then(response => {
        const pdfUrl = get(response, 'response[0].url');
        if (!!pdfUrl) {
            window.open(pdfUrl);
        }
        dispatch(simpleActions.contractEasyLoanDownloadPrintDocumentSuccess());
    })
        .catch(() => {
            dispatch(simpleActions.contractEasyLoanDownloadPrintDocumentError());
        });
};

const downloanEasyLoanContractDocument = () => (dispatch, getState) => {
    const immContractEasyLoan = getState().contractEasyLoanTypeC;
    const immAccounts = getState().accounts;

    const params = {
        header: {
            responseType: 'arraybuffer'
        },
        query: {
            year: immContractEasyLoan.get('propositionYear'),
            clientAccountCode: immAccounts.getIn(['byId', immContractEasyLoan.get('selectedAccount'), 'iban']),
            productDuration: immContractEasyLoan.get('selectedTerm').toString(),
            dueDate: DateHelper.formatDate(immContractEasyLoan.get('loanDueDate'), DATE_FORMAT_WITH_SLASHES),
            endOfMonth: immContractEasyLoan.get('paymentDaySelected') === PAYMENT_DAY_END_OF_MONTH,
            loanPurpose: loanPurposes[immContractEasyLoan.get('selectedPurpose')],
            amount: formatAmount(immContractEasyLoan.get('selectedAmount'), 'es'),
            capitalizedOpeningCommissionIndicator: immContractEasyLoan.get('indCapson'),
            propositionContractNumber: immContractEasyLoan.get('contractNumber'),
            propositionNumber: immContractEasyLoan.get('propositionNumber').toString(),
            firstTime: true, //fixed value. The user hasn't contracted the loan yet in this step. So we show a template.
            tae: formatAmount(immContractEasyLoan.get('tae'), 'es'),
            productType: PRODUCT_TYPE
        }
    };

    dispatch(simpleActions.contractEasyLoanDownloadPrintDocument());
    APIPost({ dispatch, endpoint: 'requestEasyLoanContractDocument', params }).then(response => {
        const content = get(response, 'xhr.response');
        downLoadDocumentInOtherPage(content);
        dispatch(simpleActions.contractEasyLoanDownloadPrintDocumentSuccess());
    })
        .catch(() => {
            dispatch(simpleActions.contractEasyLoanDownloadPrintDocumentError());
        });
};

const downloadINEDocument = () => (dispatch, getState) => {
    const immContractEasyLoan = getState().contractEasyLoan;

    const params = {
        header: {
            responseType: 'arraybuffer'
        },
        query: {
            year: immContractEasyLoan.get('propositionYear'),
            calculatedOpeningCommission: formatAmount(immContractEasyLoan.getIn(['openingCommission', 'amount'])),
            financedCommission: immContractEasyLoan.get('indCapson') === amortizationTypes.YES ? payrollLoanCommon.FINANCIADA : payrollLoanCommon.NO_FINANCIADA,
            productDuration: immContractEasyLoan.get('selectedTerm').toString(),
            dueDate: moment(immContractEasyLoan.get('loanDueDate')).format(DATE_FORMAT_WITH_SLASHES),
            endOfMonth: immContractEasyLoan.get('paymentDaySelected') === PAYMENT_DAY_END_OF_MONTH,
            amount: formatAmount(immContractEasyLoan.get('selectedAmount'), 'es'),
            propositionContractNumber: immContractEasyLoan.get('contractNumber'),
            propositionNumber: immContractEasyLoan.get('propositionNumber').toString(),
            firstTime: true, //fixed value. The user hasn't contracted the loan yet in this step. So we show a template.
            tae: formatAmount(immContractEasyLoan.get('tae'), 'es'),
            tin: formatAmount(immContractEasyLoan.get('tin')),
            productType: PRODUCT_TYPE
        }
    };

    dispatch(simpleActions.contractEasyLoanDownloadPrintDocument());
    APIPost({ dispatch, endpoint: 'contractEasyLoanINEDocument', params }).then(response => {
        const content = get(response, 'xhr.response');
        downLoadDocumentInOtherPage(content);
        dispatch(simpleActions.contractEasyLoanDownloadPrintDocumentSuccess());
    })
        .catch(() => {
            dispatch(simpleActions.contractEasyLoanDownloadPrintDocumentError());
        });
};

const getHiringDocumentsRequest = (getState) => {
    const immContractEasyLoan = getState().contractEasyLoan;
    const accounts = getState().accounts;
    const financedCommission = immContractEasyLoan.get('indCapson') === amortizationTypes.YES ?
        payrollLoanCommon.FINANCIADA : payrollLoanCommon.NO_FINANCIADA;
    const endOfMonth = immContractEasyLoan.get('paymentDaySelected') === PAYMENT_DAY_END_OF_MONTH;

    return {
        amount: formatAmount(immContractEasyLoan.get('selectedAmount'), 'es'),
        calculatedOpeningCommission: formatAmount(immContractEasyLoan.getIn(['openingCommission', 'amount']), 'es'),
        capitalizedOpeningCommissionIndicator: immContractEasyLoan.get('indCapson'),
        clientAccountCode: accounts.getIn(['byId', immContractEasyLoan.get('selectedAccount'), 'iban']),
        dueDate: moment(immContractEasyLoan.get('loanDueDate')).format(DATE_FORMAT_WITH_SLASHES),
        endOfMonth,
        financedCommission,
        firstTime: true, //fixed value. The user hasn't contracted the loan yet in this step. So we show a template.
        loanPurpose: loanPurposes[immContractEasyLoan.get('selectedPurpose')],
        productDuration: immContractEasyLoan.get('selectedTerm').toString(),
        propositionContractNumber: immContractEasyLoan.get('contractNumber'),
        propositionNumber: immContractEasyLoan.get('propositionNumber').toString(),
        tae: formatAmount(immContractEasyLoan.get('tae'), 'es'),
        tin: formatAmount(immContractEasyLoan.get('tin'), 'es'),
        year: immContractEasyLoan.get('propositionYear'),
        productType: PRODUCT_TYPE
    }
}

const sendLoansPrecontractualEmail = () => (dispatch, getState) => {
    const immContractEasyLoan = getState().contractEasyLoan;
    dispatch(simpleActions.payrollLoanRequestEmailPrecontractual());
    const params = {
        query: {
            producto: immContractEasyLoan.get('type'),
            standard: immContractEasyLoan.get('standard'),
            subproducto: immContractEasyLoan.get('subtype'),
            templateCode: TEMPLATE_CODE,
            hiringDocumentRequest: getHiringDocumentsRequest(getState)
        }
    };
    return APIPost({
        dispatch,
        endpoint: 'sendPrecontractualDocumentMail',
        params
    })
        .then(() => {
            dispatch(simpleActions.payrollLoanRequestEmailPrecontractualSuccess());
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.payrollLoanRequestEmailPrecontractualError());
            } else {
                throw response;
            }
        });
}

const getHiringDocuments = () => (dispatch, getState) => {
    const params = {
        header: {
            responseType: 'arraybuffer'
        },
        query: getHiringDocumentsRequest(getState)
    };

    dispatch(simpleActions.contractEasyLoanHiringDocuments());
    APIPost({ dispatch, endpoint: 'loanHiringDocuments', params })
        .then(response => {
            dispatch(simpleActions.contractEasyLoanHiringDocumentsSuccess({ response: response.xhr.response }));
            const immFlagBasedFeatures = getState().flagBasedFeatures;
            if (!__CONTACT_CENTER__ && immFlagBasedFeatures.get(PRE_CONTRACTUAL_EASY_LOAN_MAIL)) {
                dispatch(sendLoansPrecontractualEmail());
            }
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractEasyLoanHiringDocumentsError({ error: response.error }));
            } else {
                throw response;
            }
        });
};
const preFillContractEasyLoan = (segmentedLoan) => (dispatch) => {
    let openingCommission = get(segmentedLoan, 'comisionApertura', 0);
    const importe = parseFloat(get(segmentedLoan, 'importeMaximo'));
    const termMin = get(segmentedLoan, 'plazoMinimo', 0);
    const termMax = get(segmentedLoan, 'plazoMaximo', 0);

    openingCommission = parseFloat(openingCommission.replace(',', '.'));

    const openingCommissionMinimum = parseFloat(get(segmentedLoan, 'comisionAperturaMin'));
    const openingCommissionAmount = importe * openingCommission / 100;

    const comisionApertura = openingCommissionAmount < openingCommissionMinimum ?
        openingCommissionMinimum : openingCommissionAmount;

    const promiseArray = [];

    const query = {
        indCapson: 'N',
        indIntccp: 'N',
        divisa: get(segmentedLoan, 'divisa', EURO_TEXT),
        importe,
        indicaPrecios: 'E', //fixed value
        tipodeproducto: get(segmentedLoan, 'tipoPagoAniversario', 0),
        subtipodeproducto: get(segmentedLoan, 'subtipoPagoAniversario', 0),
        codigodeestandar: get(segmentedLoan, 'erPagoAniversario', 0),
        comisionApertura
    };

    if (termMax > 0) {
        const queryMin = Object.assign({}, query, { plazo: termMax });
        promiseArray.push(APIGet({ dispatch, endpoint: 'contractEasyLoanInstallments', params: { query: queryMin } }));
    }

    if (termMin > 0) {
        const queryMax = Object.assign({}, query, { plazo: termMin });
        promiseArray.push(APIGet({ dispatch, endpoint: 'contractEasyLoanInstallments', params: { query: queryMax } }));
    }

    dispatch(simpleActions.contractEasyLoanPreFill());
    return Promise.all(promiseArray)
        .then(response => (Object.assign(segmentedLoan, {
            minTae: get(response, '0.tae', {}),
            maxTae: get(response, '1.tae', {})
        })))
        .then(response => dispatch(simpleActions.contractEasyLoanPreFillSuccess({ ...response })))
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractEasyLoanPreFillError({ error: response.error }));
            } else {
                throw response;
            }
        });
};


const requestMinInstallmentQuantity = () => (dispatch, getState) => {
    const immContractTypeCLoan = getState().contractEasyLoanTypeC;
    const tin = immContractTypeCLoan.getIn(['productoActivoSegmentado', 'tipoNominal']);
    const limit = immContractTypeCLoan.get('quotaLimit');
    const totalAmount = immContractTypeCLoan.get('selectedAmount');
    const quotaLimit = totalAmount < limit ? totalAmount : limit;

    const params = {
        query: {
            tin: formatNumber(tin),
            totalAmount: formatNumber(totalAmount),
            installmentAmount: quotaLimit
        }
    };
    dispatch(simpleActions.contractEasyLoanTypecMinInstallment());
    APIGet({ dispatch, endpoint: 'minimumInstallmentQuantity', params })
        .then(response => dispatch(simpleActions.contractEasyLoanTypecMinInstallmentSuccess(response)))
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractEasyLoanTypecMinInstallmentError({ error: response.error }));
            } else {
                throw response;
            }
        });
};

const getProductInfo = (paymentDaySelected, immContractEasyLoanTypec) => {
    let type, subtype, standard, indCapson, indIntccp;

    if (paymentDaySelected === PAYMENT_DAY_END_OF_MONTH) {
        standard = immContractEasyLoanTypec.get('standard');
        subtype = immContractEasyLoanTypec.get('subtype');
        type = immContractEasyLoanTypec.get('type');
    } else {
        standard = immContractEasyLoanTypec.get('aniversaryStandard');
        subtype = immContractEasyLoanTypec.get('aniversarySubtype');
        type = immContractEasyLoanTypec.get('aniversaryType');
        indCapson = 'N';
        indIntccp = 'N';
    }

    return {
        standard,
        type,
        subtype,
        indCapson,
        indIntccp
    }
}

const getPropositionNumber = () => (dispatch, getState) => {
    const immContractEasyLoanTypec = getState().contractEasyLoanTypeC;

    if (immContractEasyLoanTypec.get('fetchingProposition')) {
        return;
    }

    const paymentDaySelected = immContractEasyLoanTypec.get('paymentDaySelected');
    const productInfo = getProductInfo(paymentDaySelected, immContractEasyLoanTypec);

    const params = {
        query: {
            importePpta: {
                importe: immContractEasyLoanTypec.get('selectedAmount'),
                divisa: immContractEasyLoanTypec.get('currency')
            },
            plazoPpta: {
                numerodeunidades: immContractEasyLoanTypec.get('selectedTerm'),
                unidaddetiempo: 'M'
            },
            finalidadPpta: '99',
            tipoPreciosOpera: 'E',
            canalOperacion: 'RED',
            estandar: {
                codigodeestandar: productInfo.standard,
                subtipodeproducto: {
                    subtipodeproducto: productInfo.subtype,
                    tipodeproducto: {
                        tipodeproducto: productInfo.type
                    }
                }
            }
        }
    };

    dispatch(simpleActions.contractEasyLoanTypecGetProposition());
    APIPost({ dispatch, endpoint: 'contractEasyLoanPropositionNumber', params })
        .then(response => {
            dispatch(getInitPropositionNumber(response))
            return dispatch(simpleActions.contractEasyLoanTypecGetPropositionSuccess(response));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractEasyLoanTypecGetPropositionError({ error: response.error }));
            } else {
                throw response;
            }
        });
};

const getEasyLoanINEDocument = () => (dispatch, getState) => {
    const immEasyLoanTypeC = getState().contractEasyLoanTypeC
    const comisionApertura = immEasyLoanTypeC.getIn(['productoActivoSegmentado', 'comisionApertura']);
    const propositionYear = immEasyLoanTypeC.get('propositionYear');
    const propositionNumber = immEasyLoanTypeC.get('propositionNumber');
    const contractNumber = immEasyLoanTypeC.get('contractNumber');
    const fechaVenci = DateHelper.formatDate(immEasyLoanTypeC.get('fechaVenci'), DATE_FORMAT_WITH_SLASHES);

    const params = {
        header: {
            version: VERSION_2
        },
        query:
        {
            year: propositionYear,
            calculatedOpeningCommission: comisionApertura || 0,
            financedCommission: immEasyLoanTypeC.get('indCapson') === amortizationTypes.YES ? payrollLoanCommon.FINANCIADA : payrollLoanCommon.NO_FINANCIADA,
            productDuration: immEasyLoanTypeC.get('selectedTerm').toString(),
            dueDate: fechaVenci,
            endOfMonth: false,
            amount: formatAmount(immEasyLoanTypeC.get('selectedAmount'), 'es'),
            propositionContractNumber: contractNumber,
            propositionNumber: propositionNumber,
            firstTime: true, //fixed value. The user hasn't contracted the loan yet in this step. So we show a template.
            tae: formatAmount(immEasyLoanTypeC.get('tae'), 'es'),
            tin: formatAmount(immEasyLoanTypeC.get('tin'), 'es'),
            productType: PRODUCT_TYPE,
        }
    };

    dispatch(simpleActions.getEasyLoanTypecIneDocument());
    APIPost({ dispatch, endpoint: 'contractEasyLoanINEDocumentV2', params }).then(response => {
        const { base64, documentId } = response;
        dispatch(simpleActions.getEasyLoanTypecIneDocumentSuccess({ base64, documentId }));
    }).catch(() => {
        dispatch(simpleActions.getEasyLoanTypecIneDocumentError());
    });
};

const checkReadDocument = () => (dispatch, getState) => {
    dispatch(simpleActions.contractEasyLoanTypecReadDocument());

}
const checkReadDocumentPolicy = () => (dispatch, getState) => {
    dispatch(simpleActions.contractEasyLoanTypecReadDocumentPolicy());

}
const sendEasyLoanSimpleEmail = (mailType, documentId) => (dispatch, getState) => {

    const immContractEasyLoanTypec = getState().contractEasyLoanTypeC;
    const immContracttInit = getState().contractInit;
    const operationProcessId = immContracttInit.get('operationProcessId')
    const scrollDown = immContractEasyLoanTypec.get('scrollDown')
    const textOfficine = formatText(translationContractLoanPdfViewerINE.SIMPLE_EMAIL)
    const acceptanceText = isPrintOfficeMode() ? textOfficine : formatText(translationContractLoanPdfViewerINE.PDF_CHECKBOX)
    const idTypeC = immContractEasyLoanTypec.get('fileEasyLoanTypecIneDocumentId')
    const idContractInit = immContracttInit.get('fileEasyLoanTypecIneDocumentId')
    const operationProccessId = idContractInit ? idContractInit : idTypeC
    const isEasyLoanEmailSent = immContractEasyLoanTypec.get('isEasyLoanEmailSent')

    const params = {
        query: {
            mailType: mailType,
            documentId: operationProccessId,
            product: {
                standard: immContractEasyLoanTypec.get('standard'),
                subType: immContractEasyLoanTypec.get('subtype'),
                type: immContractEasyLoanTypec.get('type'),
            },
            expedientId: getState().loanRecordStatus.get('recordId'),
            contractNumberAccount: '0',
            operationProcessId: operationProcessId,
            acceptanceText,
            scrollDown
        }
    };
    if (!isEasyLoanEmailSent) {

        APIPost({
            dispatch,
            endpoint: 'sendOverDraftSimpleEmail',
            params
        })
            .then(() => {
                dispatch(simpleActions.contractEasyLoanTypecEmailSuccess());
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(simpleActions.contractEasyLoanTypecEmailError());
                } else {
                    throw response;
                }
            });
    }

};
const sendEasyLoanSimpleEmailApproved = (mailType) => (dispatch, getState) => {
    const immContractEasyLoanTypec = getState().contractEasyLoanTypeC;
    const immContracttInit = getState().contractInit;
    const scrollDown = immContractEasyLoanTypec.get('scrollDown')
    const textOfficine = formatText(translationContractLoanPdfViewerINE.SIMPLE_EMAIL)
    const acceptanceText = isPrintOfficeMode() ? textOfficine : formatText(translationContractLoanPdfViewerINE.PDF_CHECKBOX)
    const idContractInit = immContracttInit.get('fileEasyLoanPolicyDocumentId')
    const operationProcessIdINE = immContracttInit.get('operationProcessIdINE')

    const params = {
        query: {
            mailType: mailType,
            documentId: idContractInit,
            product: {
                standard: immContractEasyLoanTypec.get('standard'),
                subType: immContractEasyLoanTypec.get('subtype'),
                type: immContractEasyLoanTypec.get('type'),
            },
            expedientId: getState().loanRecordStatus.get('recordId'),
            contractNumberAccount: '0',
            operationProcessId: operationProcessIdINE,
            acceptanceText,
            scrollDown
        }
    };
    APIPost({
        dispatch,
        endpoint: 'sendOverDraftSimpleEmail',
        params
    })
        .then(() => {
            dispatch(simpleActions.contractEasyLoanTypecEmailSuccess());
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractEasyLoanTypecEmailError());
            } else {
                throw response;
            }
        });
};
const formalize = (step) => (dispatch) => {
    dispatch(validateUploads());
};

const formalizeApproved = (step) => (dispatch) => {
    dispatch(validateStep(step))
};

const checkIfAllFilesWereUploaded = () => (dispatch, getState) => {
    const immContractEasyLoan = getState().contractEasyLoanTypeC;

    if (dispatch(docsUploaded())) {
        const documentsFlowIsEnable = immContractEasyLoan.get('enableDocumentsFlow');

        const params = {
            query: {
                loans: [],
                recordId: getState().loanRecordStatus.get('recordId')
            }
        }

        dispatch(simpleActions.easyLoanRequestUploadStartConfirm());
        APIPost({ dispatch, endpoint: 'payrollLoanDocumentsConfirm', params })
            .then(() => {
                //dispatch action to enable success page
                dispatch(simpleActions.easyLoanRequestUploadFileSubmit());
                dispatch(simpleActions.easyLoanRequestUploadFileReset());

                if (documentsFlowIsEnable) {
                    dispatch(simpleActions.easyLoanRequestUploadFileDisable());
                }
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(simpleActions.easyLoanRequestSaveInProgressError({ error: response.error }));
                } else {
                    throw response;
                }
            });
    }

}

const validateUploads = () => (dispatch, getState) => {
    const immContractEasyLoan = getState().contractEasyLoanTypeC;
    const immUpload = immContractEasyLoan.get('upload');

    const irpfFileWasLoaded = immUpload.getIn([IRPF_FILE, 'loaded']);
    const irpf130FileWasLoaded = immUpload.getIn([IRPF130_FILE, 'loaded']);
    const irpf100CLIFileWasLoaded = immUpload.getIn([IRPF100_CLI_FILE, 'loaded']);
    const easyLoanCertificateLoaded = immUpload.getIn([EASY_LOAN_CERTIFICATE, 'loaded']);

    const submitValidationErrorText = 'payrollLoanRequestStepThree-uploadSubmitValidationText';

    const errorHandler = (uploadName, message, idx) => {
        dispatch(simpleActions.easyLoanRequestUploadFileError({ uploadName, message, idx }));
    }

    if (!irpfFileWasLoaded) {
        errorHandler(IRPF_FILE, submitValidationErrorText);
    }

    if (!easyLoanCertificateLoaded) {
        errorHandler(EASY_LOAN_CERTIFICATE, submitValidationErrorText);
    }

    if (!irpf130FileWasLoaded) {
        errorHandler(IRPF130_FILE, submitValidationErrorText);
    }
    if (!irpf100CLIFileWasLoaded) {
        errorHandler(IRPF100_CLI_FILE, submitValidationErrorText);
    }

    dispatch(checkIfAllFilesWereUploaded());
}

const validateStep = step => (dispatch, getState) => {
    const visibleStep = getState().contractEasyLoanTypeC.get('visibleStep');
    const beforeStep = getState().contractEasyLoanTypeC.get('beforeStep');
    const selectedPurpose = getState().contractEasyLoanTypeC.get('selectedPurpose');
    const agreeTypeCINECheckbox = getState().contractEasyLoanTypeC.get(isPrintOfficeMode() ? 'officePrintStepTwo' : 'agreeTypeCINECheckbox');
    const emptyIncome = getState().contractEasyLoanTypeC.getIn(['outcome', 'income']);
    const jobError = validateJobInformationDrago(getState);
    const contractEasyLoanTypeC = getState().contractEasyLoanTypeC
    const contractInit = getState().contractInit
    const idTypeC = contractEasyLoanTypeC.get('fileEasyLoanTypecIneDocumentId')
    const idContractInit = contractInit.get('fileEasyLoanTypecIneDocumentId')
    const operationProccessId = idContractInit ? idContractInit : idTypeC
    if (visibleStep === WIZARD_FIRST_STEP && !!selectedPurpose && !!emptyIncome && beforeStep === DEFAULT_BEFORE_STEP && !jobError) {
        dispatch(easyLoanTypeCSaveInProgress())
            .then(() => dispatch(requestLoanApproval()))
            .then(() => dispatch(simpleActions.contractEasyLoanTypecValidateStep(step)))
            .then(() => dispatch(getPropositionNumber()));

    } else if (visibleStep === WIZARD_SECOND_STEP && agreeTypeCINECheckbox) {
        dispatch(sendEasyLoanSimpleEmail(EASY_LOAN_MAILTYPE.PRECONTRACTUAL, operationProccessId))
        dispatch(simpleActions.contractEasyLoanTypecValidateStep(step));
    }
    else if (visibleStep - 1 === WIZARD_SECOND_STEP) {
        if (!__CONTACT_CENTER__ || isPrintOfficeMode()) {
        } else {
            if (__CONTACT_CENTER__ || !isPrintOfficeMode()) {
                dispatch(simpleActions.easyLoanRequestUploadFileSubmitContactCenter());
            } else {
                dispatch(simpleActions.easyLoanRequestUploadFileSubmit());
            }

            return true;
        }
    }
    else {
        step !== undefined && dispatch(simpleActions.contractEasyLoanTypecValidateStep(step));
    }
};

const getTotalImportForStepTwo = () => (dispatch, getState) => {
    const immContractEasyLoan = getState().contractEasyLoanTypeC;
    const endOfMonth = immContractEasyLoan.get('paymentDaySelected') === 'PAYMENT_DAY_END_OF_MONTH';
    dispatch(simpleActions.contractEasyLoanTypecGetTotalImport());
    const params = {
        query: {
            comisionApertura: immContractEasyLoan.get('openingCommission').get('amount'),
            comisionAperturaMin: parseInt(immContractEasyLoan.get('openingCommission').get('minimum')),
            valorPrestamo: parseInt(immContractEasyLoan.get('selectedAmount')),
            cuota: immContractEasyLoan.getIn(['installment', 'amount']),
            numeroPagos: parseInt(immContractEasyLoan.get('selectedTerm')),
            finDeMes: endOfMonth,
            tin: immContractEasyLoan.get('tin')
        }
    };

    return APIGet({ dispatch, endpoint: 'requestEasyLoanContractTotalAmount', params })
        .then(response => {
            dispatch(simpleActions.contractEasyLoanTypecGetTotalImportSuccess({ totalAmount: response.totalAmount }));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractEasyLoanTypecGetTotalImportError({ error: response.error }));
            } else {
                throw response;
            }
        });
};

const getPurposes = () => dispatch => {
    dispatch(simpleActions.contractEasyLoanTypecGetPurposes());
    APIGet({ dispatch, endpoint: 'payrollLoanGetPurposes' })
        .then(response => {
            dispatch(simpleActions.contractEasyLoanTypecGetPurposesSuccess({ response }));
        }).catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractEasyLoanTypecGetPurposesError());
            } else {
                throw response;
            }
        });
}
const getInstallmentRequest = (initValue = false) => (dispatch, getState) => {
    const immContractTypeCLoan = getState().contractEasyLoanTypeC;
    const productInfo = getProductInfo(immContractTypeCLoan.get('paymentDaySelected'), immContractTypeCLoan);
    const initialized = immContractTypeCLoan.get('initialized');
    const divisa = immContractTypeCLoan.getIn(['productoActivoSegmentado', 'divisa']);
    const importeMaximo = !initValue ? immContractTypeCLoan.get('selectedAmount') : immContractTypeCLoan.getIn(['productoActivoSegmentado', 'importeMaximo']);
    const plazo = !initialized ? immContractTypeCLoan.get('selectedTerm') : immContractTypeCLoan.getIn(['productoActivoSegmentado', 'plazoMaximo']);
    const tipodeproducto = immContractTypeCLoan.getIn(['productoActivoSegmentado', 'tipo']);
    const subtipodeproducto = immContractTypeCLoan.getIn(['productoActivoSegmentado', 'subtipo']);
    const codigodeestandar = immContractTypeCLoan.getIn(['productoActivoSegmentado', 'standard']);
    const comisionApertura = immContractTypeCLoan.getIn(['productoActivoSegmentado', 'comisionApertura']);
    const params = {
        query: {
            indCapson: productInfo.indCapson,
            indIntccp: productInfo.indIntccp,
            divisa,
            importe: formatNumber(importeMaximo, 'es'),
            indicaPrecios: 'E', //fixed value
            plazo,
            tipodeproducto,
            subtipodeproducto,
            codigodeestandar,
            comisionApertura: formatNumber(comisionApertura, 'es')
        }
    };

    dispatch(simpleActions.contractEasyLoanTypecInstallment());
    return APIGet({ dispatch, endpoint: 'contractEasyLoanInstallments', params })
        .then(response => {
            dispatch(simpleActions.contractEasyLoanTypecInstallmentSuccess({ response }))
            initValue && dispatch(initialize())
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractEasyLoanTypecInstallmentError({ error: response.error }));
            } else {
                throw response;
            }
        });
};


const initialize = () => (dispatch, getState) => {
    const immContractTypeCLoan = getState().contractEasyLoanTypeC;
    const expDate = immContractTypeCLoan.getIn(['productoActivoSegmentado', 'fechaVigencia']);
    const importeMaximo = immContractTypeCLoan.getIn(['productoActivoSegmentado', 'importeMaximo']);
    const tin = immContractTypeCLoan.getIn(['productoActivoSegmentado', 'tipoNominal']);
    const plazoMaximo = immContractTypeCLoan.getIn(['productoActivoSegmentado', 'plazoMaximo']);
    const tae = immContractTypeCLoan.get('tae')

    let params = {
        query: {
            expDate,
            tae: tae,
            tin: formatNumber(tin, 'es'),
            amount: formatNumber(importeMaximo),
            term: plazoMaximo
        }
    };

    dispatch(simpleActions.contractEasyLoanTypecInitialize());
    APIPost({ dispatch, endpoint: 'easyLoanTypeCInitialize', params })
        .then(response => {
            dispatch(simpleActions.contractEasyLoanTypecInitializeSuccess({ response }));
            dispatch(getInstallmentRequest());
            dispatch(getLoanRecordStatus());
        }).catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractEasyLoanTypecInitializeError({ error: response.error }));
            } else {
                throw response;
            }
        });
};

const getLoansForExpenses = () => (dispatch, getState) => {
    const immContractTypeCLoan = getState().contractEasyLoanTypeC;
    const immLoan = getState().loans;
    const loansInformation = immLoan.get('loansByOrder');
    const mortgagesInformation = immLoan.get('mortgagesByOrder');
    const loansById = immLoan.get('byId');
    const loansAndMortgages = loansInformation.concat(mortgagesInformation);
    const loansAndMortgagesValues = loansAndMortgages.map(id => {
        const loanData = loansById.find(loan => loan.get('loanId') === id);
        return {
            'newContractNumber': loanData.get('newContractNumber'),
            'productName': loanData.get('alias').trim(),
            'productType': loanData.get('newProduct')
        }
    });

    const params = {
        query: {
            loans: loansAndMortgagesValues.toArray()
        }
    };

    dispatch(simpleActions.easyLoanTypecRequestGetLoansForExpenses());
    return APIPost({ dispatch, endpoint: 'loans', params })
        .then(response => {
            const informationLoans = get(response, 'loans', []);
            let subMortgages = immContractTypeCLoan.getIn(['outcome', 'mortgage']) || 0;
            let subOtherLoansInstallments = immContractTypeCLoan.getIn(['outcome', 'others']) || 0;
            // store totalMonthlyFee only
            informationLoans.map(item => {
                const loanFullInfo = loansById.find(loan => loan.get('contractNumber') === item.newContractNumber);
                if (loanFullInfo.get('isMortgage')) {
                    subMortgages = subMortgages.toFixed(2) - parseFloat(item.monthlyFee);
                } else {
                    subOtherLoansInstallments = subOtherLoansInstallments.toFixed(2) - parseFloat(item.monthlyFee);
                }
            });
            dispatch(simpleActions.easyLoanTypecRequestGetLoansForExpensesSuccess({ response }));
        }).catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.easyLoanTypecRequestGetLoansForExpensesError({ error: response.error }));
            } else {
                throw response;
            }
        });
}

const getJobsInformation = () => dispatch => {
    dispatch(getLoansForExpenses())
    dispatch(getPurposes())
    dispatch(simpleActions.contractEasyLoanTypecGetJobs());
    APIGet({ dispatch, endpoint: 'payrollLoanGetJobsInfo' })
        .then(response => {
            dispatch(simpleActions.contractEasyLoanTypecGetJobsSuccess({ response }));
        }).catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractEasyLoanTypecGetJobsError());
            } else {
                throw response;
            }
        });
}

const getDocumentType = (uploadName) => {
    let documentType;

    if (uploadName === EASY_LOAN_CERTIFICATE) {
        documentType = NOM_VL;
    }
    else if (uploadName === IRPF_FILE) {
        documentType = IRPF100;
    }
    else if (uploadName === IRPF100_FILE) {
        documentType = NEW_IRPF100_FILE;
    }
    else if (uploadName === IRPF130_FILE) {
        documentType = IRPF130;
    }
    else if (uploadName === IRPF100_CLI_FILE_2) {
        documentType = IRPF100_CLI_2;
    }

    else if (uploadName === IRPF100_CLI_FILE_3) {
        documentType = IRPF100_CLI_3;
    }
    else if (uploadName === IRPF100_CLI_FILE_4) {
        documentType = IRPF100_CLI_4;
    }
    else if (uploadName === IRPF100_CLI_FILE) {
        documentType = IRPF100_CLI;
    }

    return documentType;
}

const docsUploaded = () => (dispatch, getState) => {
    const immEasyLoanTypeC = getState().contractEasyLoanTypeC;
    const immUpload = immEasyLoanTypeC.get('upload');
    const requiredDocs = immUpload.get('requiredDocs');
    const fileTypesWithFileCheck = ['IRPF100_CLI_FILE', 'IRPF100_CLI_FILE_2', 'IRPF100_CLI_FILE_3'];
    const fileTypesWithoutFileCheck = ['IRPF_FILE', 'IRPF130_FILE'];
    const fileTypesWithoutFileCheckCertificate = ['EASY_LOAN_CERTIFICATE'];

    const fileStatus = {
        IRPF_FILE: { uploaded: false },
        IRPF130_FILE: { uploaded: false },
        EASY_LOAN_CERTIFICATE: { uploaded: false },
        ...fileTypesWithFileCheck.reduce((acc, fileType) => {
            acc[fileType] = { uploaded: false };
            return acc;
        }, {})
    };
    Object.entries(requiredDocs.toJS()).forEach(([fileType, file]) => {
        const fileUploaded = immUpload.getIn([fileType, 'uploaded']);
        const isFileObject = typeof file === 'object';

        if (fileTypesWithoutFileCheck.includes(fileType) || fileTypesWithFileCheck.includes(fileType) || fileTypesWithoutFileCheckCertificate.includes(fileType)) {
            if (isFileObject && fileUploaded) {
                fileStatus[fileType].uploaded = true;
            }
        }
    });

    const areFileTypesWithoutFileCheckUploaded = fileTypesWithoutFileCheck.every(fileType => {
        return fileStatus[fileType] ? fileStatus[fileType].uploaded : true;
    });

    const areFileTypesWithFileCheckUploaded = fileTypesWithFileCheck.every(fileType => {
        return fileStatus[fileType] ? fileStatus[fileType].uploaded : false;
    });
    const isIRPFFileUploaded = fileStatus.IRPF_FILE.uploaded;
    const isIRPFFileUploadedCertificate = fileStatus.EASY_LOAN_CERTIFICATE.uploaded;
    const areRequiredFilesUploaded = isIRPFFileUploadedCertificate || areFileTypesWithoutFileCheckUploaded || (areFileTypesWithFileCheckUploaded && isIRPFFileUploaded);

    return areRequiredFilesUploaded;
};


const loadFilesEasyLoan = () => (dispatch, getState) => {
    const recordId = getState().loanRecordStatus.get('recordId')
    const recordIdTypeC = getState().contractEasyLoanTypeC.get('recordId')

    const params = {
        query: {
            recordId: recordId || recordIdTypeC
        }
    };
    dispatch(simpleActions.easyLoanRequestLoadFiles());
    APIGet({ dispatch, endpoint: 'easyLoanDocument', params })
        .then(response => {
            dispatch(simpleActions.easyLoanRequestLoadFilesSuccess({ response }));
        }).catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.easyLoanRequestLoadFilesError());
            } else {
                throw response;
            }
        });
}

const requestLoanApproval = () => (dispatch, getState) => {
    const immEasyLoanTypeC = getState().contractEasyLoanTypeC;

    let params = {
        query: {
            acceptedText: formatText('contractEasyLoanTypeC-labelCirbeCheckbox'),
            notificationId: "",
            productId: EASY_LOAN_TYPEC_CRIBE_CONST,
            recordId: immEasyLoanTypeC.get('recordId'),
        }
    };

    dispatch(simpleActions.contractEasyLoanTypecRequestApproval());
    return APIPost({ dispatch, endpoint: 'payrollLoanApprovalAndCirbe', params })
        .then(response => {
            const status = response.preApprovalStatus || '';
            if (status === PRE_APPROVAL_OK) {
                dispatch(simpleActions.contractEasyLoanTypecRequestApprovalApproved({ response }));
            } else {
                dispatch(simpleActions.contractEasyLoanTypecRequestApprovalRejected({ response }));
            }
        }).catch(response => {
            if (response?.error?.status === ASNEF_VALIDATION_ERROR) {
                dispatch(simpleActions.contractEasyLoanTypecAsnefFailure());
            } else if (!!response.error) {
                dispatch(simpleActions.contractEasyLoanTypecRequestApprovalError({ error: response.error }));
            } else {
                throw response;
            }
        });
};
const editNameFilesForEasyLoan = (parameters) => (dispatch, getState) => {
    const recordId = getState().loanRecordStatus.get('recordId')
    const { response: { nameFile, typeFile, documentId, idx, receiptDefaultName } } = parameters;
    const query = new FormData();
    const documentType = getDocumentType(typeFile);
    const documentName = nameFile !== "" ? nameFile : receiptDefaultName;

    query.append(
        'request',
        new Blob([JSON.stringify({
            documentType,
            recordId,
            documentName,
            documentId: documentId
        })],
            { type: 'application/json' })
    );

    const params = {
        header: {
            version: VERSION_2
        },
        query
    };
    dispatch(simpleActions.easyoanRequestEditNameFile({ uploadName: typeFile, idx }));
    return APIPost({ dispatch, endpoint: 'easyLoanUploadFile', params, contentType: false })
        .then(() => {
            const response = Object.assign({}, parameters.response, { nameFile: documentName });
            dispatch(simpleActions.easyLoanRequestEditNameFileSuccess({ response }));
        }).catch(() => {
            dispatch(simpleActions.easyLoanRequestEditNameFileError({ uploadName: typeFile, message: messageDeleteOrChangeNameErrorText, idx }));
        });
}

const uploadFilesForEasyLoan = (parameters) => (dispatch, getState) => {
    const recordId = getState().loanRecordStatus.get('recordId')
    const { response: { file, uploadName, idx, messageSnackSuccess, fileLabel } } = parameters;
    if (uploadName === EASY_LOAN_CERTIFICATE) {
        parameters.newName = getTranslatedDocumentName(NOM_VL);
    }
    else if (uploadName === IRPF_FILE) {
        parameters.newName = getTranslatedDocumentName(IRPF100);
    }
    else if (uploadName === IRPF130_FILE) {
        parameters.newName = getTranslatedDocumentName(IRPF130);
    }
    else if (uploadName === IRPF100_FILE) {
        parameters.newName = getTranslatedDocumentName(NEW_IRPF100_FILE);
    }
    else if (uploadName === IRPF100_CLI_FILE) {
        parameters.newName = getTranslatedDocumentName(IRPF100_CLI);
    }
    else if (uploadName === IRPF100_CLI_FILE_2) {
        parameters.newName = getTranslatedDocumentName(IRPF100_CLI_2);
    }
    else if (uploadName === IRPF100_CLI_FILE_3) {
        parameters.newName = getTranslatedDocumentName(IRPF100_CLI_3);
    }
    else if (uploadName === IRPF100_CLI_FILE_4) {
        parameters.newName = getTranslatedDocumentName(IRPF100_CLI_4);
    }

    const documentType = getDocumentType(uploadName);

    const query = new FormData();
    query.append('file', file);

    query.append(
        'request',
        new Blob([JSON.stringify({
            documentType,
            recordId,
            documentName: parameters.newName
        })],
            { type: 'application/json' })
    );

    const params = {
        header: {
            version: VERSION_2
        },
        query
    };
    dispatch(simpleActions.easyLoanRequestUploadFile({ uploadName, idx }));
    return APIPost({ dispatch, endpoint: 'easyLoanUploadFile', params, contentType: false })
        .then(() => {
            recordEasyLoanCUploadFileSuccess(fileLabel);
            dispatch(notificationActions.success({ message: messageSnackSuccess }, { voice: messageSnackSuccess }));
            dispatch(simpleActions.easyLoanRequestUploadFileLoad(parameters));
        }).catch(() => {
            dispatch(simpleActions.easyLoanRequestUploadFileError({ uploadName, message: messageUploadExternalErrorText, idx }));
        });
}

const removeFileForEasyLoan = (parameters) => (dispatch, getState) => {
    const recordId = getState().loanRecordStatus.get('recordId')
    const { idx, documentId, uploadName } = parameters;
    const documentType = getDocumentType(uploadName);
    const params = {
        query: {
            recordId,
            documentId,
            documentType
        }
    };
    dispatch(simpleActions.easyLoanRequestUploadFileRemove({ uploadName, idx }));
    return APIPost({ dispatch, endpoint: 'easyLoanDeleteFile', params })
        .then(() => {
            dispatch(simpleActions.easyLoanRequestUploadFileRemoveSuccess({ response: parameters }));
        }).catch(() => {
            dispatch(simpleActions.easyLoanRequestUploadFileRemoveError({ uploadName, message: messageDeleteOrChangeNameErrorText, idx }));
        });
}

const clearErrors = (parameters) => (dispatch) => dispatch(simpleActions.easyLoanRequestClearErrorsFile(parameters))

const formalizeQuery = () => (dispatch, getState) => {
    const immContractEasyLoanTypeC = getState().contractEasyLoanTypeC;
    const immContractEasyLoan = getState().contractEasyLoan;
    const immContractEasyLoanInit = getState().contractInit;
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const immAccounts = getState().accounts.get('byId');
    const immAccount = immAccounts.get(immContractEasyLoanTypeC.get('selectedAccount'));
    const fechaVencimiento = immContractEasyLoan.get('loanDueDate');
    const documentId = immContractEasyLoanInit.get('fileEasyLoanPolicyDocumentId');
    const scrollDown = immContractEasyLoanTypeC.get('scrollDownPolicy')
    const textOfficine = formatText(translationContractLoanPdfViewerINE.SIMPLE_EMAIL)
    const acceptanceText = isPrintOfficeMode() ? textOfficine : formatText(translationContractLoanPdfViewerINE.PDF_CHECKBOX)
    let diaPagoFinMes;
    let fechaPrimerCargo;

    if (immContractEasyLoan.get('paymentDaySelected') === PAYMENT_DAY_END_OF_MONTH) {
        diaPagoFinMes = amortizationTypes.YES;
        fechaPrimerCargo = immContractEasyLoan.get('lackDate') || immContractEasyLoan.get('chargeOffDate');
    } else {
        diaPagoFinMes = amortizationTypes.NO;
        fechaPrimerCargo = immContractEasyLoan.get('chargeOffAnniversaryDate');
    }

    const params = {
        header: {
            version: VERSION_2
        },
        query: {
            accountBban: immAccount.getIn(['ibanComplex', 'codbban']),
            accountContractNumber: immAccount.get('newContractNumber'),
            accountPrefix: immAccount.getIn(["ibanComplex", "pais"]) + immAccount.getIn(["ibanComplex", "digitodecontrol"]), // IBAN
            amount: formatAmount(immContractEasyLoanTypeC.get('selectedAmount'), 'es'),
            capitalizedOpeningCommissionIndicator: immContractEasyLoanTypeC.get('indCapson'),
            dueDate: fechaVencimiento,
            endOfMonth: immContractEasyLoan.get('paymentDaySelected') === PAYMENT_DAY_END_OF_MONTH,
            endOfMonthDate: diaPagoFinMes,
            financedCommission: !!immContractEasyLoan.get('indCapson'),
            firstChargeDate: fechaPrimerCargo,
            installment: formatAmount(immContractEasyLoan.getIn(['installment', 'amount']), 'es'),
            propositionContractNumber: immContractEasyLoan.get("contractNumber"),
            propositionContractProduct: 143,
            propositionNumber: immContractEasyLoan.get('propositionNumber'),
            registerDate: moment().startOf('day').format(DATE_FORMAT_API),
            tae: formatAmount(immContractEasyLoan.get('tae'), 'es'),
            year: immContractEasyLoan.get('propositionYear'),
            loanPurpose: immContractEasyLoan.get('selectedPurpose'),
            productType: 1,
            termsAndConds: {
                acceptanceText
            },
            operationProcessId: immContractEasyLoan.get('operationProcessIdINE'),
            product: immAccount.get('newProduct'),
            documentId: documentId,
            mailType: EASY_LOAN_MAILTYPE.CONTRACTUAL,
            scrollDown,
            subProduct: immContractEasyLoan.get('subtype'),
            term: immContractEasyLoanTypeC.get('selectedTerm')
        }
    };
    if (immFlagBasedFeatures.get(EASY_LOAN_LEGAL_CHECK)) {
        const acceptedTextSplit = formatText('contractEasyLoanStepThree-contractEasyLoanStepThree_contractEasyLoanAgreeCheckboxLabel').split('%s');
        const injectedLinks = [
            formatText('contractEasyLoanStepThree-contractEasyLoanStepThree_contractEasyLoanIneDocument'),
            formatText('contractEasyLoanStepThree-contractEasyLoanStepThree_contractEasyLoanPreApprovedDocument'),
            formatText('contractEasyLoanStepThree-contractEasyLoanStepThree_contractEasyLoanContractDocument')
        ];

        params.query.termsAndConds = termsAndConds;
    }
    if (immFlagBasedFeatures.get(NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES) && getState().flagBasedFeatures.get(EVIDENCE_EASY_LOAN)) {
        params.query.operationProcessId = immContractEasyLoan.get('operationProcessIdPolicy')
    }
    return APIPost({ dispatch, endpoint: 'contractEasyLoanFormalize', params })
        .then(() => dispatch(simpleActions.contractEasyLoanFormalizeSuccess()))
        .catch(() => dispatch(simpleActions.contractEasyLoanFormalizeError()));
};

const validateApproveStep = step => (dispatch, getState) => {
    const immContractEasyLoanTypeC = getState().contractEasyLoanTypeC;
    const visibleStep = immContractEasyLoanTypeC.get('visibleStep');
    const newEasyLoanFeatureFlag = getState().flagBasedFeatures.get(NOT_ALLOWED_NEW_PREAPPROVAL_LOAN_FLOW_COUNTRIES);

    if (visibleStep === WIZARD_FIRST_STEP && newEasyLoanFeatureFlag) {
        dispatch(getAsnefValidation());
        dispatch(getLoanInitINEContractDocumentsPreaproved(EASY_LOAN_MAILTYPE.CONTRACTUAL)).then(() => {
            dispatch(getInitPropositionNumberPolicy(true));
            dispatch(simpleActions.contractEasyLoanValidateStepApproved({ step, newEasyLoanFeatureFlag }));
        })
    } else if (visibleStep === WIZARD_SECOND_STEP && newEasyLoanFeatureFlag) {
        const callback = (dispatch, getState, dataToken) => {
            dispatch(formalizeQuery())

        };
        validateAndExecute(dispatch, getState, callback, true)
    }
    else {
        dispatch(simpleActions.contractEasyLoanValidateStepApproved({ step, newEasyLoanFeatureFlag }));
    }
};
const checkStepThree = () => (dispatch, getState) => {
    dispatch(simpleActions.contractEasyLoanTypecStepThree());
}
const saveContinueLater = () => (dispatch, getState) => {
    const visibleStep = getState().contractEasyLoanTypeC.get('visibleStep');
    visibleStep === 1 && dispatch(easyLoanTypeCSaveInProgress())
};

module.exports = {
    downloadINEDocument,
    downloadPreContractDocument,
    downloanEasyLoanContractDocument,
    formalize,
    getHiringDocuments,
    getInstallment,
    getInstallmentApprove,
    onDownloadDocument,
    onPrintDocument,
    preFillContractEasyLoan,
    requestMinInstallmentQuantity,
    simpleActions,
    validateStep,
    setNewJobType,
    setEmploymentLevel,
    setContractType,
    setOutcome,
    initialize,
    getJobsInformation,
    easyLoanTypeCSaveInProgress,
    getLoansForExpenses,
    getTotalImportForStepTwo,
    requestLoanApproval,
    getPurposes,
    setPurpose,
    getInstallmentRequest,
    loadFilesEasyLoan,
    editNameFilesForEasyLoan,
    uploadFilesForEasyLoan,
    removeFileForEasyLoan,
    clearErrors,
    docsUploaded,
    getEasyLoanINEDocument,
    sendEasyLoanSimpleEmail,
    validateApproveStep,
    checkReadDocument,
    getPropositionNumber,
    sendEasyLoanSimpleEmailApproved,
    checkStepThree,
    checkReadDocumentPolicy,
    formalizeApproved,
    getInstallmentPreapproved,
    saveContinueLater,
    contractEasyLoanTypecAsnefFailureReset,
};
